// extracted by mini-css-extract-plugin
export var container = "styles-module--container--wxsW4";
export var titleContainer = "styles-module--title-container--hwW6s";
export var title = "styles-module--title--SZD8X";
export var description = "styles-module--description--CcopY";
export var thumbnailContainer = "styles-module--thumbnail-container--VY0vR";
export var thumbnail = "styles-module--thumbnail--YyOmR";
export var metaContainer = "styles-module--meta-container--4iN25";